import { Action } from '../actions'
import {
  USER_RESOURCES_FETCH_REQUESTED,
  USER_RESOURCES_FETCH_SUCCEEDED,
  USER_RESOURCES_FETCH_FAILED,
} from '../actionTypes'

const initialState = {
  resources: [],
  resourcesLoaded: false,
  activeResource: {
    embedConfigLoaded: false,
    embedConfig: undefined,
  },
  message: undefined,
}

// Assign the arrow function to a named constant
const resourcesReducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case USER_RESOURCES_FETCH_REQUESTED:
      return {
        ...state,
      }
    case USER_RESOURCES_FETCH_SUCCEEDED:
      const { resources } = action.payload
      return {
        ...state,
        resources,
        resourcesLoaded: true,
      }
    case USER_RESOURCES_FETCH_FAILED:
      const { resourceMessage } = action.payload
      return {
        ...state,
        resources: [],
        resourcesLoaded: false,
        message: resourceMessage,
      }
    default:
      return state
  }
}

// Export the named constant as the default export
export default resourcesReducer
